import type { Project } from "@mux/sdk/v2/client"
import type { ProjectMeta } from "./types"

export function createProjectIndex(projects: readonly Project[]) {
  const index = new Map<string, Project>()
  for (const project of projects) {
    if (project.id) index.set(project.id, project)
    if (project.directory) index.set(project.directory, project)
    if (project.worktree) index.set(project.worktree, project)
  }
  return index
}

export function createProjectController(input: {
  setProjects: (next: Project[] | ((draft: Project[]) => void)) => void
  setMeta: (directory: string, patch: ProjectMeta) => void
  setIcon: (directory: string, value: string | undefined) => void
}) {
  return {
    meta: input.setMeta,
    icon: input.setIcon,
    removeOptimistic(id: string) {
      input.setProjects((draft) => {
        const index = draft.findIndex((project) => project.id === id)
        if (index !== -1) draft.splice(index, 1)
      })
    },
    replaceOptimistic(id: string, project: Project) {
      input.setProjects((draft) => {
        const index = draft.findIndex((item) => item.id === id)
        if (index === -1) {
          draft.push(project)
          return
        }
        draft[index] = project
      })
    },
    updateOptimistic(id: string, patch: Partial<Project>) {
      input.setProjects((draft) => {
        const index = draft.findIndex((project) => project.id === id)
        if (index !== -1) draft[index] = { ...draft[index], ...patch }
      })
    },
    addOptimistic(project: Project) {
      input.setProjects((draft) => {
        if (draft.some((item) => item.id === project.id)) return
        const created = project.time?.created ?? 0
        const insertIndex = draft.findIndex(
          (item) => (item.time?.created ?? 0) < created,
        )
        if (insertIndex === -1) draft.push(project)
        else draft.splice(insertIndex, 0, project)
      })
    },
  }
}
